import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_2 = {
  key: 0,
  class: "mt-1 text-sm text-red-600"
}

import { DatePicker } from 'v-calendar'
import { computed, ref, watch } from 'vue'

import { dateObjectToServerDay } from '@/helpers/dates'
import api from '@/store/api'
import NeueToggle from '@/components/neue/NeueToggle.vue'


export default {
  __name: 'NewReportModal',
  props: {
  isOpen: Boolean,
  audience: Object,
  bottle: Object,
  simplifiedForPayouts: { type: Boolean, default: false },
  payoutDateRange: { type: Object, default: null },
  simplifiedReportType: { type: String, default: null },
  dateBasisNote: { type: String, default: null }
},
  emits: ['closeModal'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const modalTitle = computed(() => {
  if (props.simplifiedForPayouts) return 'Download payout report'
  if (props.simplifiedReportType === 'recurring_membership_fees') return 'Download recurring membership fees report'
  if (props.simplifiedReportType === 'meal_plans') return 'Download meal plans report'
  if (props.simplifiedReportType === 'products') return 'Download products sold breakdown report'
  if (props.simplifiedReportType === 'upsell_sales') return 'Download upsell sales report'
  if (props.simplifiedReportType === 'website_form_leads') return 'Download inquiry form leads'
  if (props.simplifiedReportType === 'website_chat_leads') return 'Download chat widget leads'
  if (props.simplifiedReportType === 'lead_capture_page_leads') return 'Download lead capture page signups'
  if (props.simplifiedReportType === 'bottle_by_range') return 'Download orders spreadsheet'
  if (props.simplifiedReportType === 'revenue') return 'Download revenue summary report'
  if (props.simplifiedReportType === 'discount_code_usage') return 'Download discount code usage report'
  if (props.simplifiedReportType === 'referral_code_usage') return 'Download referral code usage report'
  if (props.simplifiedReportType === 'customer_growth_by_tier') return 'Download customer growth by tier report'
  if (props.simplifiedReportType === 'membership_tier_growth') return 'Download membership tier growth report'
  if (props.simplifiedReportType === 'revenue_by_membership_tier') return 'Download revenue by membership tier report'
  return 'Download a report'
})

const type = ref(null)
const email = ref(null)
const emailReportEnabled = ref(false)
const audienceList = ref('orders')
const audienceListOptions = [
  {
    name: 'Orders',
    value: 'orders',
    description: 'Paid orders only. Unpaid carts and cancelled orders are left out.'
  },
  {
    name: 'Orders + Carts that will be charged',
    value: 'orders-and-will-be-charged',
    description: 'Paid orders, plus unpaid carts that are set to be charged automatically.'
  },
  {
    name: 'Invoiced Orders',
    value: 'invoiced',
    description:
      "Only orders placed on an invoice, paid or not. If you don't send your customers invoices, this report will have no orders."
  }
]
const audienceListDescription = computed(
  () => audienceListOptions.find(option => option.value === audienceList.value)?.description
)
const when = ref(null)
const pickingDate = ref(0)
const options = ref([])

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const emailValid = computed(() => !email.value?.trim() || emailRegex.test(email.value.trim()))
const emailRequiredAndValid = computed(() => Boolean(email.value?.trim()) && emailRegex.test(email.value.trim()))

if (props.audience) {
  api.call('GET', 'data_downloads/audiences').then(x => (options.value = x.data.data.map(y => y.attributes)))
} else if (props.bottle) {
  api.call('GET', 'data_downloads/bottles').then(x => (options.value = x.data.data.map(y => y.attributes)))
} else {
  api.call('GET', 'data_downloads/reports').then(x => (options.value = x.data.data.map(y => y.attributes)))
}

watch(
  () => props.isOpen,
  () => {
    if (!props.isOpen) return // only reset on open to avoid flash when closing modal
    if (props.simplifiedForPayouts || props.simplifiedReportType) {
      email.value = ''
      emailReportEnabled.value = false
      return
    }
    if (props.audience) {
      type.value = 'BottleDataDownload'
    } else if (props.bottle) {
      type.value = 'bottle'
    } else {
      type.value = 'bottle_by_range'
    }
    email.value = ''
    when.value = { start: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), end: new Date() }
    pickingDate.value = 0
  }
)

const modalValid = computed(() => {
  if (props.simplifiedForPayouts || props.simplifiedReportType) {
    const rangeOk = props.payoutDateRange?.beginning_date && props.payoutDateRange?.ending_date
    const emailOk = !emailReportEnabled.value || emailRequiredAndValid.value
    return rangeOk && emailOk
  }
  return type.value && (type.value === 'users' || props.audience ? true : when.value) && pickingDate.value === 0
})

const send = () => {
  if ((props.simplifiedForPayouts || props.simplifiedReportType) && props.payoutDateRange) {
    const payloadEmail = emailReportEnabled.value ? email.value?.trim() || '' : ''
    const reportType = props.simplifiedReportType || 'payouts'
    const payload = {
      report_type: reportType,
      email: payloadEmail,
      beginning_date: props.payoutDateRange.beginning_date,
      ending_date: props.payoutDateRange.ending_date
    }
    if (reportType === 'revenue') {
      const sIds = props.payoutDateRange.store_ids ?? []
      if (sIds.length > 0) payload.store_ids = sIds
      payload.group_by = props.payoutDateRange.group_by ?? 'day'
    }
    if (reportType === 'bottle_by_range') {
      const fmIds = props.payoutDateRange.fulfillment_method_ids ?? []
      if (fmIds.length > 0) {
        payload.fulfillment_method_ids = fmIds
      }
      if (props.payoutDateRange.reseller_id) {
        payload.reseller_id = props.payoutDateRange.reseller_id
      }
    }
    if (reportType === 'discount_code_usage') {
      const sIds = props.payoutDateRange.store_ids ?? []
      if (sIds.length > 0) payload.store_ids = sIds
      const dcIds = props.payoutDateRange.discount_code_ids ?? []
      if (dcIds.length > 0) payload.discount_code_ids = dcIds
    }
    if (reportType === 'referral_code_usage') {
      const sIds = props.payoutDateRange.store_ids ?? []
      if (sIds.length > 0) payload.store_ids = sIds
      const rcIds = props.payoutDateRange.referral_code_ids ?? []
      if (rcIds.length > 0) payload.referral_code_ids = rcIds
    }
    if (reportType === 'customer_growth_by_tier') {
      const sIds = props.payoutDateRange.store_ids ?? []
      if (sIds.length > 0) payload.store_ids = sIds
    }
    if (reportType === 'membership_tier_growth') {
      const sIds = props.payoutDateRange.store_ids ?? []
      if (sIds.length > 0) payload.store_ids = sIds
    }
    if (reportType === 'revenue_by_membership_tier') {
      const sIds = props.payoutDateRange.store_ids ?? []
      if (sIds.length > 0) payload.store_ids = sIds
      const mtIds = props.payoutDateRange.membership_tier_ids ?? []
      if (mtIds.length > 0) payload.membership_tier_ids = mtIds
      payload.group_by = props.payoutDateRange.group_by ?? 'day'
    }
    if (reportType === 'products' || reportType === 'upsell_sales') {
      const sIds = props.payoutDateRange.store_ids ?? []
      if (sIds.length > 0) payload.store_ids = sIds
      const pIds = props.payoutDateRange.product_ids ?? []
      if (pIds.length > 0) payload.product_ids = pIds
    }
    if (reportType === 'website_form_leads' || reportType === 'website_chat_leads') {
      if (props.payoutDateRange.agent_id) payload.agent_id = props.payoutDateRange.agent_id
    }
    api.call('POST', 'data_downloads', { data_download: payload })
    emit('closeModal')
    return
  }
  if (props.audience) {
    api.call('POST', `audiences/${props.audience.id}/data_downloads`, {
      data_download: {
        type: type.value,
        email: email.value,
        audience_list: audienceList.value
      }
    })
  } else if (props.bottle) {
    api.call('POST', `bottles/${props.bottle.id}/data_downloads`, {
      data_download: {
        report_type: type.value,
        email: email.value
      }
    })
  } else {
    const payload = {
      report_type: type.value,
      email: email.value,
      ...(type.value !== 'users' && {
        beginning_date: dateObjectToServerDay(when.value.start),
        ending_date: dateObjectToServerDay(when.value.end)
      })
    }
    if (type.value === 'revenue') {
      payload.store_id = ''
      payload.group_by = 'day'
    }
    api.call('POST', 'data_downloads', { data_download: payload })
  }

  emit('closeModal')
}

return (_ctx, _cache) => {
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_InputField = _resolveComponent("InputField")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_NeueButton = _resolveComponent("NeueButton")
  const _component_TheModal = _resolveComponent("TheModal")

  return (_openBlock(), _createBlock(_component_TheModal, {
    "is-open": props.isOpen,
    "modal-title": modalTitle.value,
    onCloseModal: _cache[10] || (_cache[10] = $event => (_ctx.$emit('closeModal')))
  }, {
    main: _withCtx(() => [
      _createVNode(_component_FormSection, {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers($event => (modalValid.value && send()), ["prevent"]))
      }, {
        default: _withCtx(() => [
          (!props.simplifiedForPayouts && !props.simplifiedReportType)
            ? (_openBlock(), _createBlock(_component_FormElement, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectInput, {
                    modelValue: type.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((type).value = $event)),
                    name: "Report type",
                    options: options.value
                  }, null, 8, ["modelValue", "options"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (props.audience && !props.simplifiedForPayouts && !props.simplifiedReportType)
            ? (_openBlock(), _createBlock(_component_FormElement, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectInput, {
                    modelValue: audienceList.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((audienceList).value = $event)),
                    name: "Orders/carts to pull",
                    options: audienceListOptions,
                    description: audienceListDescription.value
                  }, null, 8, ["modelValue", "description"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (
            type.value !== 'users' &&
            !props.audience &&
            !props.bottle &&
            !props.simplifiedForPayouts &&
            !props.simplifiedReportType
          )
            ? (_openBlock(), _createBlock(_component_FormElement, { key: 2 }, {
                default: _withCtx(() => [
                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-1" }, "Start and end date for the report", -1)),
                  _createVNode(_unref(DatePicker), {
                    modelValue: when.value,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = $event => ((when).value = $event)),
                      _cache[4] || (_cache[4] = $event => (pickingDate.value = -1))
                    ],
                    modelModifiers: { range: true },
                    mode: "date",
                    "is-required": "",
                    onClick: _cache[3] || (_cache[3] = $event => (pickingDate.value++))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (props.simplifiedForPayouts || props.simplifiedReportType)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                (props.dateBasisNote)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(props.dateBasisNote), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_FormElement, null, {
                  default: _withCtx(() => [
                    _createVNode(NeueToggle, {
                      modelValue: emailReportEnabled.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((emailReportEnabled).value = $event)),
                      name: "Email this report when finished creating?",
                      description: "We'll email you the report when it's ready."
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                (emailReportEnabled.value)
                  ? (_openBlock(), _createBlock(_component_FormElement, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InputField, {
                          modelValue: email.value,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((email).value = $event)),
                          name: "Email address",
                          placeholder: "michael@bluthcompany.com",
                          error: emailReportEnabled.value && !!email.value?.trim() && !emailValid.value
                        }, null, 8, ["modelValue", "error"]),
                        (emailReportEnabled.value && !!email.value?.trim() && !emailValid.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Please enter a valid email address. "))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createBlock(_component_FormElement, { key: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputField, {
                    modelValue: email.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((email).value = $event)),
                    name: "Email to send report to when finished creating (optional)",
                    placeholder: "michael@bluthcompany.com"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_NeueButton, {
        type: "secondary",
        onClick: _cache[9] || (_cache[9] = $event => (_ctx.$emit('closeModal')))
      }, {
        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
          _createTextVNode("Cancel", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_NeueButton, {
        type: modalValid.value ? 'primary' : 'inactive',
        onClick: send
      }, {
        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
          _createTextVNode("Download", -1)
        ]))]),
        _: 1
      }, 8, ["type"])
    ]),
    _: 1
  }, 8, ["is-open", "modal-title"]))
}
}

}